export default "__VITE_ASSET__HL451XRT__"